import { toRGBA } from '@cuemath/comps';
import { openModal } from 'actions/modal';
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import COLORS from 'constants/colors';
import { useUnderMaintenance } from 'modules/hooks/use-maintenance';

const MaintenanceScreen = () => {
  const dispatch = useDispatch();
  const { underMaintenance, maintenanceEndTsFromCF } = useUnderMaintenance();

  const handleOpenModal = useCallback(() => {
    dispatch(
      openModal(
        'maintenance',
        {
          blocking: true,
          size: 'custom',
          width: '512px',
          height: 'auto',
          radius: '0px',
          backdropFilter: true,
          backdropFilterData: {
            blurValue: 'blur(40px)',
            bgColor: toRGBA(COLORS.BLACK, 0.38),
          },
        },
        {
          underMaintenance,
          maintenanceEndTs: maintenanceEndTsFromCF,
        },
      ),
    );
  }, [dispatch, maintenanceEndTsFromCF, underMaintenance]);

  useEffect(() => {
    if (underMaintenance) {
      handleOpenModal();
    }
  }, [handleOpenModal, underMaintenance]);

  return null;
};

export default MaintenanceScreen;
